import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getResponseStatsKey,
  getResponseStatsOptions,
  type ResponseStatsKeyParams,
} from './getResponseStats.options';

export function useGetResponseStats(params: ResponseStatsKeyParams) {
  return useSuspenseQuery(getResponseStatsOptions(params));
}

useGetResponseStats.getQueryKey = getResponseStatsKey;
